import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initClarity } from "../common/utils/clarity";

export default function ClarityProvider() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const hostname = window.location.hostname;

    const blockedDomains = [
      "dev.jaaga.ai",
      "stage.jaaga.ai",
      "devpartner.jaaga.ai",
      "devadmin.jaaga.ai",
      "admin.jaaga.ai",
      "localhost",
      "127.0.0.1",
    ];
    const blockedRoutes = ["/admin", "/servicepartner"];

    const isBlockedDomain = blockedDomains.includes(hostname);
    const isBlockedRoute = blockedRoutes.some((route) =>
      path.startsWith(route),
    );

    const isBlocked = isBlockedDomain || isBlockedRoute;

    if (isBlocked) {
      const script = document.getElementById("clarity-script");
      if (script) {
        script.remove();
      }

      if (window.clarity) {
        window.clarity = function () {};
      }

      return;
    }

    initClarity();
  }, [location.pathname]);

  return null;
}
